import React from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { motion, AnimatePresence } from '@utils/framerMotionProxy';
import { useAuth } from '../../contexts/AuthContext';

const MobileMenu = ({ isOpen, onClose, navigationItems, onNavigate }) => {
  const { t } = useTranslation();
  const { user, isAuthenticated, logout } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();
  const headerNavTextClass = 'text-white hover:text-gray-200 transition-colors font-bold text-sm';
  const desktopAccountButtonClass = 'inline-flex w-full items-center gap-2 px-6 py-3 bg-transparent hover:bg-transparent rounded-none text-white hover:text-gray-200 transition-colors font-bold text-sm uppercase text-left justify-start';

  const handleNavigate = (href) => {
    onNavigate(href);
    onClose();
  };

  const handleAdminLogout = async () => {
    await logout();
    onClose();
    navigate('/');
  };

  return (
    <AnimatePresence>
      {isOpen && (
        <>
          {/* Overlay */}
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            onClick={onClose}
            className="fixed inset-0 backdrop-blur-sm z-40 lg:hidden"
          />

          {/* Menu */}
          <motion.div
            initial={{ x: '100%' }}
            animate={{ x: 0 }}
            exit={{ x: '100%' }}
            transition={{ type: 'tween', duration: 0.3 }}
            className="fixed top-0 right-0 h-full w-64 max-w-[72vw] z-50 lg:hidden"
            style={{
              backgroundColor: '#EC8C8E',
              backgroundImage: "url('/images/web-images/flower2.svg')",
              backgroundRepeat: 'no-repeat',
              backgroundPosition: 'left bottom',
              backgroundSize: '185% auto'
            }}
          >
            <div className="flex flex-col h-full">
              {/* Close */}
              <div className="flex items-center justify-end p-6">
                <button
                  onClick={onClose}
                  className="p-2 text-white hover:text-gray-200 transition-colors"
                >
                  <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                  </svg>
                </button>
              </div>

              {/* Navigation */}
              <nav className="flex-1 py-6">
                <ul className="space-y-1">
                  {navigationItems.map((item) => (
                    <li key={item.key}>
                      <button
                        onClick={() => handleNavigate(item.href)}
                        className={`w-full text-left px-6 py-3 ${headerNavTextClass}`}
                      >
                        {item.label}
                      </button>
                    </li>
                  ))}
                </ul>

                {/* Auth Section */}
                <div className="mt-8">
                  {isAuthenticated ? (
                    <div className="space-y-3">
                      <Link
                        to={user?.role === 'admin' ? '/admin' : '/account'}
                        state={user?.role === 'admin' ? undefined : { backgroundLocation: location }}
                        onClick={onClose}
                        className={desktopAccountButtonClass}
                      >
                        {user?.role === 'admin' ? t('nav.admin').toUpperCase() : t('nav.account').toUpperCase()}
                      </Link>
                      {user?.role === 'admin' && (
                        <button
                          type="button"
                          onClick={handleAdminLogout}
                          className={desktopAccountButtonClass}
                        >
                          {t('nav.logout').toUpperCase()}
                        </button>
                      )}
                    </div>
                  ) : (
                    <div className="space-y-3">
                      <Link
                        to="/auth"
                        state={{ backgroundLocation: location }}
                        onClick={onClose}
                        className={desktopAccountButtonClass}
                      >
                        {t('nav.account').toUpperCase()}
                      </Link>
                    </div>
                  )}
                </div>
              </nav>
            </div>
          </motion.div>
        </>
      )}
    </AnimatePresence>
  );
};

export default MobileMenu;
